// components/GenericPopup.tsx
import React, { ReactNode } from 'react';
import './GenericPopup.scss';

interface GenericPopupProps {
  isOpen: boolean;
  title: string;
  children: ReactNode;
  onClose: () => void;
  
  primaryButtonText?: string;
  onPrimaryClick?: () => void;
  primaryButtonDisabled?: boolean; 

  secondaryButtonText?: string;
  onSecondaryClick?: () => void;
}

export const GenericPopup: React.FC<GenericPopupProps> = ({
  isOpen,
  title,
  children,
  onClose,
  primaryButtonText,
  onPrimaryClick,
  primaryButtonDisabled = false, 
  secondaryButtonText,
  onSecondaryClick,
}) => {
  if (!isOpen) return null;

  return (
    <div className="asthma-wrapper">
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-container" onClick={(e) => e.stopPropagation()}>
        
        <button className="popup-close-btn" onClick={onClose}>
          ✕
        </button>

        <div className="popup-content-wrapper">
          <h3 className="popup-title">{title}</h3>
          
          <div className="popup-body">
            {children}
          </div>

          <div className="popup-actions">
            {secondaryButtonText && (
              <button 
                type="button" 
                className="popup-btn popup-btn-secondary" 
                onClick={onSecondaryClick}
              >
                {secondaryButtonText}
              </button>
            )}

            {primaryButtonText && (
              <button 
                type="button" 
          
                className={`popup-btn popup-btn-primary ${primaryButtonDisabled ? 'disabled' : ''}`}
                disabled={primaryButtonDisabled} 
                onClick={onPrimaryClick}
              >
                {primaryButtonText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};